import moment from 'moment'
moment.locale('zh-cn')

const NumFormat = function (val) {
    if (val === '' || val == null) {
        return '0.00'
    }
    let value = Number(val).toFixed(2)
    let s = value.toString().indexOf('.')
    if (s === -1) {
        return (value || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    } else {
        let arr = value.toString().split('.')
        return (arr[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + arr[1]
    }
}
const numFilter = function (value) {
    if (!value) {
        return 0.0
    } else {
        let realVal = parseFloat(value).toFixed(2)
        return realVal
    }
}
// 日期 YYYY-MM-DD HH:mm
const formatDate = function (time, param) {
    if (param) {
        return moment(time).format(param)
    }
    return moment(time).format('YYYY-MM-DD HH:mm:ss')
}

// 日期 YYYY/MM/DD HH:mm
const formatDate2 = function (time, param) {
    if (param) {
        return moment(time).format(param)
    }
    return moment(time).format('YYYY/MM/DD HH:mm')
}

// 日期 YYYY.MM.DD HH:mm
const formatDate3 = function (time, param) {
    if (param) {
        return moment(time).format(param)
    }
    return moment(time).format('YYYY.MM.DD HH:mm')
}

// 日期 MM-DD HH:mm
const formatDate4 = function (time, param) {
    if (param) {
        return moment(time).format(param)
    }
    return moment(time).format('MM-DD HH:mm')
}

/**
 * @description: 用于隐藏手机号中间的7位数，保留前3后2
 * @param {type} string 手机号
 * @return: string 过滤后的手机号
 */
const phoneHide = function (value = '') {
    if (!value) {
        return value
    } else {
        let hidestr = '******'
        return value.substr(0, 3) + hidestr + value.substring(value.length - 2)
    }
}

export default {
    NumFormat,
    formatDate,
    formatDate2,
    formatDate3,
    formatDate4,
    numFilter,
    phoneHide
}
